// extracted by mini-css-extract-plugin
module.exports = {"root":"Ovr1OOu2","option":"Sv0YfPis","active":"dBlfIoFJ"};